import script from "./KpiWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiWidget.vue?vue&type=script&setup=true&lang=js"

import "./KpiWidget.vue?vue&type=style&index=0&id=304c0288&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304c0288"]])

export default __exports__